import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { BreakpointService } from './services/breakpoint.service';
import { ThemeService } from './services/theme.service';
import { register } from 'swiper/element/bundle';
register();


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
 
  constructor(
    private platform: Platform,
    private themeService: ThemeService,
    private breakpointService: BreakpointService,
    private router: Router
  ) {
    this.initializeApp();
    this.router.events.subscribe(value => {
      // if (value instanceof NavigationEnd && value.url === '/login') {
      //   this.loginUrl = true;
      // } else {
      //   this.loginUrl = false;
      // }
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    this.breakpointService.onResize(event.target.innerWidth);
  }

  /**
   * Initialize app
   */
  initializeApp() {
    this.platform.ready().then(() => {
      this.themeService.detectSystemTheme();
      this.breakpointService.onResize(this.platform.width());
    });
  }
}
